import { Vue } from 'vue-property-decorator';

const currency_settings: Intl.NumberFormatOptions = {
  style: 'currency',
  minimumFractionDigits: 0,
};

const date_settings: Intl.DateTimeFormatOptions = {
  day: 'numeric',
  month: 'numeric',
  year: 'numeric',
  // timeZone: 'Europe/Moscow',
};

const filters: { [index: string]: () => string } = {
  date: (value?: string | null) => {
    if (value) {
      const date = new Date(value);

      return Intl.DateTimeFormat('ru-RU', date_settings).format(date);
    }
    return '';
  },

  date_time: (value?: string | null) => {
    if (value) {
      const date = new Date(value);

      return Intl.DateTimeFormat('ru-RU', {
        ...date_settings,
        hour: '2-digit',
        minute: '2-digit',
      }).format(date).replace(',', '');
    }
    return '';
  },

  currency_rub: (value?: number | string | null, n?: number) => {
    const num_val = Number(value);

    if (value !== null && !Number.isNaN(num_val)) {
      const intl_settings = {
        ...currency_settings,
        currency: 'RUB',
        minimumFractionDigits: Number.isInteger(num_val) ? 0 : 2,
      };

      return Intl.NumberFormat('ru-RU', intl_settings).format(num_val).replace(',', '.');
    }
    return '';
  },

  currency_rub_rounded: (value?: number | string | null, n?: number) => {
    const num_val = Number(value);

    if (value !== null && !Number.isNaN(num_val)) {
      const intl_settings = {
        ...currency_settings,
        currency: 'RUB',
      };
      const rounded = Math.round(num_val);

      return Intl.NumberFormat('ru-RU', intl_settings).format(rounded).replace(',', '.');
    }
    return '';
  },

  currency_usd_rounded: (value?: number | string | null) => {
    const num_val = Number(value);

    if (value !== null && !Number.isNaN(num_val)) {
      const intl_settings = {
        ...currency_settings,
        currency: 'USD',
      };
      const rounded = Math.round(num_val);

      return Intl.NumberFormat('ru-RU', intl_settings).format(rounded);
    }
    return '';
  },
};

export default function register_filters(): void {
  Object.keys(filters).forEach((f) => {
    Vue.filter(f, filters[f]);
  });
}
